import { gql } from '@apollo/client'
import React from 'react'

import { formsClient } from '../../../../utils/apollo/api'
import { useQuery } from '../../../../utils/apollo/_helpers/useQuery'
import StatePresenter from '../../../../components/helpers/StatePresenter'

const Context = React.createContext([])
const { Provider } = Context
export const useFormState = () => React.useContext(Context)
export const useForm = () => useFormState()?.form

const QUERY = gql`
  query Form($id: ID) {
    form(id: $id) {
      id
      name
      description
    }
  }
`

const FormLoader = ({ children, id }) => {
  const { data, ...state } = useQuery(QUERY, {
    skip: !id,
    variables: { id },
    client: formsClient,
    fetchPolicy: 'no-cache'
  })

  return (
    <StatePresenter {...state}>
      <Provider value={data}>{children}</Provider>
    </StatePresenter>
  )
}

export default FormLoader
